// ----------------------------------------------------------------------------
// Template: Collection
// ----------------------------------------------------------------------------
//
// ----------------------------------------------------------------------------


// -------------------------------------
// Dependencies
// -------------------------------------

// Scripts
import 'sections/header/header';
import 'snippets/breadcrumbs/breadcrumbs';
import 'snippets/card/card';
import 'snippets/pagination/pagination';
import 'snippets/collection-driver/collection-driver';
import 'snippets/collection-filters-sort/collection-filters-sort';
import 'sections/page-header/page-header';
import 'sections/footer/footer';


// Styles
import './_collection.scss';

function applyBorderToggleToCheckbox(checkbox) {
    const card = checkbox.closest('.card');
    if (!card) return;
    const imageWrapper = card.querySelector('.card__image-wrapper');
    if (!imageWrapper) return;

    function toggleBorder() {
        if (checkbox.checked) {
            imageWrapper.style.border = '1px solid #242526';
        } else {
            imageWrapper.style.border = '';
        }
    }

    toggleBorder(); // initial check
    checkbox.addEventListener('change', toggleBorder);
}

const observer = new MutationObserver(mutations => {
    mutations.forEach(mutation => {
        mutation.addedNodes.forEach(node => {
            if (!(node instanceof HTMLElement)) return;

            // Check if node contains a compare checkbox or is a checkbox itself
            if (node.matches && node.matches('.sp-compare-main input[type="checkbox"]')) {
                applyBorderToggleToCheckbox(node);
            } else {
                // Check descendants for checkboxes
                node.querySelectorAll && node.querySelectorAll('.sp-compare-main input[type="checkbox"]').forEach(applyBorderToggleToCheckbox);
            }
        });
    });
});

// Start observing the whole document or a specific container where products load
observer.observe(document.body, { childList: true, subtree: true });

// Also run on any checkboxes already present on page load
document.querySelectorAll('.sp-compare-main input[type="checkbox"]').forEach(applyBorderToggleToCheckbox);

